<app-admin-page-shell
  titleKey="app.admin.identity.title"
  subtitleKey="app.admin.identity.subtitle"
  [panelled]="false"
>
  <div class="identity-admin-content">
    <section class="platform-flags" aria-label="Identity layer controls">
      <div class="platform-flags__header">
        <h2 class="platform-flags__title">
          {{ 'app.admin.identity.layer.title' | translate }}
        </h2>
        <p class="platform-flags__hint">
          {{ 'app.admin.identity.layer.hint' | translate }}
        </p>
      </div>

      @if (overviewLoading()) {
        <p class="platform-flags__loading">
          {{ 'app.admin.identity.loading' | translate }}
        </p>
      } @else if (overviewError()) {
        <div class="platform-flags__error">
          <p>{{ 'app.admin.identity.error' | translate }}</p>
          <app-cta-button size="small" (clicked)="loadOverview()">
            <span cta-label>{{ 'app.admin.identity.retry' | translate }}</span>
          </app-cta-button>
        </div>
      } @else {
        @if (overview(); as config) {
          <ul class="platform-flags__list">
            <li class="platform-flag">
              <div class="platform-flag__copy">
                <p class="platform-flag__name">
                  {{ 'app.admin.identity.layer.flagName' | translate }}
                </p>
                <p class="platform-flag__description">
                  {{ 'app.admin.identity.layer.flagDescription' | translate }}
                </p>
              </div>
              <app-admin-toggle-switch
                [checked]="config.layerEnabled"
                [disabled]="layerToggleBusy()"
                [ariaLabel]="'app.admin.identity.layer.flagName' | translate"
                (checkedChange)="toggleLayer($event)"
              />
            </li>
            <li class="platform-flag">
              <div class="platform-flag__copy">
                <p class="platform-flag__name">
                  {{ 'app.admin.identity.fullyVerifiedCourse.flagName' | translate }}
                </p>
                <p class="platform-flag__description">
                  {{
                    'app.admin.identity.fullyVerifiedCourse.flagDescription'
                      | translate
                  }}
                </p>
              </div>
              <app-admin-toggle-switch
                [checked]="config.fullyVerifiedRequiresCourse"
                [disabled]="courseRequirementToggleBusy() || !config.layerEnabled"
                [ariaLabel]="
                  'app.admin.identity.fullyVerifiedCourse.flagName' | translate
                "
                (checkedChange)="toggleFullyVerifiedRequiresCourse($event)"
              />
            </li>
          </ul>

          <dl class="config-summary">
            <div class="config-summary__row">
              <dt>{{ 'app.admin.identity.overview.graceDays' | translate }}</dt>
              <dd>{{ config.legacyGraceDays }}</dd>
            </div>
            <div class="config-summary__row">
              <dt>{{ 'app.admin.identity.overview.kycProvider' | translate }}</dt>
              <dd>{{ config.kycProvider }}</dd>
            </div>
          </dl>
        }
      }
    </section>

    <section class="grace-backfill" aria-label="Legacy grace backfill">
      <div class="grace-backfill__header">
        <h2 class="grace-backfill__title">
          {{ 'app.admin.identity.grace.title' | translate }}
        </h2>
        <p class="grace-backfill__hint">
          {{ 'app.admin.identity.grace.hint' | translate }}
        </p>
      </div>

      <div class="grace-backfill__actions">
        <app-cta-button
          size="small"
          [disabled]="backfillBusy() || overviewLoading()"
          (clicked)="runGraceBackfill()"
        >
          <span cta-label>
            @if (backfillBusy()) {
              {{ 'app.admin.identity.grace.running' | translate }}
            } @else {
              {{ 'app.admin.identity.grace.run' | translate }}
            }
          </span>
        </app-cta-button>

        @if (backfillError()) {
          <p class="grace-backfill__error">
            {{ 'app.admin.identity.grace.error' | translate }}
          </p>
        } @else if (backfillResult() !== null) {
          <p class="grace-backfill__result">
            {{
              'app.admin.identity.grace.result'
                | translate: { count: backfillResult() }
            }}
          </p>
        }
      </div>
    </section>

    <section class="integration-link" aria-label="Partner integration review">
      <div class="integration-link__header">
        <h2 class="integration-link__title">
          {{ 'app.admin.identity.integrationReview.linkTitle' | translate }}
        </h2>
        <p class="integration-link__hint">
          {{ 'app.admin.identity.integrationReview.linkHint' | translate }}
        </p>
      </div>
      <a class="integration-link__cta" routerLink="/identity/integration-requests">
        {{ 'app.admin.identity.integrationReview.linkCta' | translate }}
      </a>
    </section>
  </div>
</app-admin-page-shell>
